import user from '@/api/user'
// 其他模块的接口……

// 导出接口
export default {
  user
  // ……
}
